/**
 * Extract plain text from a message's content parts. Ignores tool-call parts
 * and any parts without a usable `text` string. Used by the per-message
 * speaker button to derive TTS input without relying on DOM reads.
 */
export function messageToPlainText(message: unknown): string {
  if (!message || typeof message !== "object") return "";
  const content = (message as { content?: unknown }).content;
  if (!Array.isArray(content)) return "";
  const parts: string[] = [];
  for (const part of content) {
    if (
      part &&
      typeof part === "object" &&
      (part as { type?: unknown }).type === "text" &&
      typeof (part as { text?: unknown }).text === "string"
    ) {
      parts.push((part as { text: string }).text);
    }
  }
  return parts.join("\n\n").trim();
}
